// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3dD6m","options":"AnswerScale_options__2CUtX","selected":"AnswerScale_selected__3jqJ6"};